<template>
  <tr :class="{ 'hidden': isHidden }">
    <slot />
  </tr>
</template>

<script lang="ts">

import { DEFAULT_ATTRIBUTE_LIMIT } from '~~/constants/alternativeProducts';

export default defineComponent({
  name: 'ComparisonTableRow',
  props: {
    showMore: {
      type: Boolean,
      required: true,
    },
    rowNumber: {
      type: Number,
      required: true,
    },
  },
  setup(props) {

    const isHidden = computed(() => !props.showMore && props.rowNumber > DEFAULT_ATTRIBUTE_LIMIT);

    return {
      isHidden,
    };
  
  },
});


</script>
